import React from 'react';
import {
	ApButtonGroup,
	ApButtonMain,
	ApLoaderDefault,
	ApLoaderText,
	ApChip,
} from '@alixpartners/ui-components';
import RadioGroup from 'components/RadioGroup';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { ApiDataContext } from 'contexts/ApiDataContext';
import { SettingsContext } from 'contexts/SettingsContext';
import {
	Wrapper,
	Content,
	SectionTitle,
	StyledRadio,
	StyledButtonSecondary,
	Section,
	SubheaderSection,
	SubheaderText,
	SubheaderHelper,
	SubheaderTags,
	StyledModal,
	LoadingWrapper,
	LoadingFooter,
} from './styles';
import {
	getMonthByDate,
	getYearByDate,
	convertToArray,
	EMPTY_VALUE,
} from 'Details/utils';
import { MONTH_NAMES } from 'utils/date';
import { updateSpendType } from 'utils/apiRequests';
import { VENDOR_TYPES } from 'Details/utils';
import capitilize from 'lodash/capitalize';

const OPTIONS = {
	ALL: 1,
	DATE_ONLY: 2,
	ALL_FILTERS: 3,
};

const SPEND_TYPE = {
	INDIRECT: '1',
	DIRECT: '0',
};

const TAXONOMY_NAMES = {
	vendor: 'vendor',
	category: 'category',
	division: 'purchasing company',
};

const DIMENSION_LABELS = {
	costCentre: 'cost center',
};

export class ChangeTypeModal extends React.Component {
	state = {
		selectedOption: OPTIONS.ALL_FILTERS,
		isSourceable: null,
		isLoading: false,
	};

	getCustomFilters() {
		const { storedQueryId, storedQuery } = this.props;
		let { customFiltersValues, customFilters } = this.props;

		if (storedQueryId) {
			if (storedQuery) {
				({ customFiltersValues, customFilters } = storedQuery);
			} else {
				customFiltersValues = [];
				customFilters = [];
			}
		}

		return { customFiltersValues, customFilters };
	}

	onTransactionChange = e => {
		this.setState({
			isSourceable: null,
			selectedOption: Number(e.target.value),
		});
	};

	onSpendTypeChange = e => {
		this.setState({ isSourceable: e.target.value === 'true' });
	};

	updateSelectedSpendType = () => {
		const { isSourceable, selectedOption } = this.state;
		let {
			supplierId,
			dateFrom,
			dateTo,
			hierarchy,
			showNonSourceable,
			isHarmonized,
			customFiltersValues,
			customFilters,
			clearApiCache,
			categoryHierarchy,
			divisionName,
			categoryName,
			dimensionName,
			dimensions,
			onClose,
			includeCustomCategories,
			waterfallFilter,
			selectedDimensionKey,
			selectedDimensionName,
			selectedDimensionId,
			storedQueryId,
			spendType,
			onSubmit,
			extraFilters,
			isPmi,
			directTaxonomy,
		} = this.props;
		includeCustomCategories = Number(directTaxonomy) === 2 ? true : false;
		const params = {
			includeCustomCategories,
		};
		const dimensionValue =
			selectedDimensionKey === 'spendType'
				? SPEND_TYPE[selectedDimensionName.toUpperCase()]
				: selectedDimensionName;

		switch (selectedOption) {
			case OPTIONS.ALL:
				if (dimensionName) {
					params.filters = [dimensions[0]];
					params.filterValues = [dimensionName];
				}

				if (selectedDimensionKey) {
					params.filters = [selectedDimensionKey];
					params.filterValues = [dimensionValue];
				} else if (supplierId) {
					const filterName = !isHarmonized
						? VENDOR_TYPES.original
						: VENDOR_TYPES.harmonized;

					params.filters = [filterName];
					params.filterValues = [supplierId];
				} else if (categoryHierarchy) {
					params.hierarchy = categoryHierarchy;
				} else if (divisionName) {
					params.filters = ['purchasingLegalEntity'];
					params.filterValues = [divisionName];
				} else if (categoryName) {
					const filterName = includeCustomCategories
						? 'clientCategoryL4'
						: 'categoryL4';

					params.filters = [filterName];
					params.filterValues = [categoryName];
				}

				break;
			case OPTIONS.DATE_ONLY:
				params.dateFrom = dateFrom;
				params.dateTo = dateTo;

				if (dimensionName) {
					params.filters = [dimensions[0]];
					params.filterValues = [dimensionName];
				}

				if (selectedDimensionKey) {
					params.filters = [selectedDimensionKey];
					params.filterValues = [dimensionValue];
				} else if (supplierId) {
					const filterName = !isHarmonized
						? VENDOR_TYPES.original
						: VENDOR_TYPES.harmonized;

					params.filters = [filterName];
					params.filterValues = [supplierId];
				} else if (categoryHierarchy) {
					params.hierarchy = categoryHierarchy;
				} else if (divisionName) {
					params.filters = ['purchasingLegalEntity'];
					params.filterValues = [divisionName];
				} else if (categoryName) {
					const filterName = includeCustomCategories
						? 'clientCategoryL4'
						: 'categoryL4';

					params.filters = [filterName];
					params.filterValues = [categoryName];
				}

				break;
			case OPTIONS.ALL_FILTERS:
				params.dateFrom = dateFrom;
				params.dateTo = dateTo;
				params.filters = ['sourceable'];
				params.filterValues = [showNonSourceable !== 'true'];

				if (dimensionName) {
					params.filters = [...params.filters, dimensions[0]];
					params.filterValues = [...params.filterValues, dimensionName];
				}

				if (selectedDimensionKey) {
					const filterName = selectedDimensionKey;

					params.filters = [...params.filters, selectedDimensionKey];
					params.filterValues = [...params.filterValues, dimensionValue];

					if (hierarchy) {
						params.hierarchy = hierarchy;
					}

					if (filterName !== dimensions[0]) {
						params.filters = [
							...params.filters,
							...(waterfallFilter ? [waterfallFilter[0]] : []),
						];
						params.filterValues = [
							...params.filterValues,
							...(waterfallFilter ? [waterfallFilter[1]] : []),
						];
					}
				} else if (supplierId) {
					const filterName = !isHarmonized
						? VENDOR_TYPES.original
						: VENDOR_TYPES.harmonized;

					params.filters = [...params.filters, filterName];
					params.filterValues = [...params.filterValues, supplierId];

					if (hierarchy) {
						params.hierarchy = hierarchy;
					}

					if (filterName !== dimensions[0]) {
						params.filters = [
							...params.filters,
							...(waterfallFilter ? [waterfallFilter[0]] : []),
						];
						params.filterValues = [
							...params.filterValues,
							...(waterfallFilter ? [waterfallFilter[1]] : []),
						];
					}
				} else if (categoryHierarchy) {
					params.hierarchy = categoryHierarchy;
					params.filters = [
						...params.filters,
						...(waterfallFilter ? [waterfallFilter[0]] : []),
					];
					params.filterValues = [
						...params.filterValues,
						...(waterfallFilter ? [waterfallFilter[1]] : []),
					];
				} else if (divisionName) {
					params.filters = [
						...params.filters,
						'purchasingLegalEntity',
						...(waterfallFilter ? [waterfallFilter[0]] : []),
					];
					params.filterValues = [
						...params.filterValues,
						divisionName,
						...(waterfallFilter ? [waterfallFilter[1]] : []),
					];

					if (hierarchy) {
						params.hierarchy = hierarchy;
					}
				} else if (categoryName) {
					const filterName = includeCustomCategories
						? 'clientCategoryL4'
						: 'categoryL4';

					params.filters = [
						...params.filters,
						filterName,
						...(waterfallFilter ? [waterfallFilter[0]] : []),
					];
					params.filterValues = [
						...params.filterValues,
						categoryName,
						...(waterfallFilter ? [waterfallFilter[1]] : []),
					];

					if (hierarchy) {
						params.hierarchy = hierarchy;
					}
				}

				if (customFiltersValues.length > 0) {
					params.filters = [...params.filters, ...customFilters];
					params.filterValues = [
						...params.filterValues,
						...customFiltersValues,
					];
				}

				if (isPmi && spendType) {
					params.filters = [...(params.filters || []), 'spendType'];
					params.filterValues = [
						...(params.filterValues || []),
						SPEND_TYPE[spendType],
					];
				}

				if (extraFilters) {
					const filterObj = Object.keys(extraFilters).reduce(
						(acc, filterName) => {
							return {
								...acc,
								filters: [
									...acc.filters,
									...new Array(extraFilters[filterName].length).fill(
										filterName
									),
								],
								filterValues: [
									...acc.filterValues,
									...extraFilters[filterName],
								],
							};
						},
						{
							filters: [],
							filterValues: [],
						}
					);

					params.filters = [...params.filters, ...filterObj.filters];
					params.filterValues = [
						...params.filterValues,
						...filterObj.filterValues,
					];
				}

				if (storedQueryId) {
					params.storedQueryId = storedQueryId;
				}

				break;
			default:
				break;
		}

		if (!isPmi && spendType) {
			params.filters = [...(params.filters || []), 'spendType'];
			params.filterValues = [
				...(params.filterValues || []),
				SPEND_TYPE[spendType],
			];
		}

		this.setState({
			isLoading: true,
		});
		if (selectedDimensionId) {
			let isDirect;
			if (selectedDimensionId.startsWith('Direct')) {
				isDirect = true;
			} else if (selectedDimensionId.startsWith('Indirect')) {
				isDirect = false;
			} else {
				console.warn('Does not start with Direct or Indirect');
			}

			if (isDirect) {
				params.includeCustomCategories = true;
			} else {
				params.includeCustomCategories = false;
			}
		} else {
			if (spendType === 'DIRECT') {
				params.includeCustomCategories = true;
			}
			if (spendType === 'INDIRECT') {
				params.includeCustomCategories = false;
			}
		}

		updateSpendType(params, { sourceable: isSourceable })
			.then(() => {
				this.setState({ isLoading: false });
				clearApiCache();

				onClose();

				if (onSubmit) {
					onSubmit();
				}
			})
			.catch(() => {
				this.setState({ isLoading: false });
			});
	};

	getName = () => {
		const {
			divisionName,
			categoryName,
			supplierName,
			categoryHierarchy,
			dimensionName,
			selectedDimensionName,
		} = this.props;

		return (
			categoryName ||
			supplierName ||
			divisionName ||
			dimensionName ||
			(categoryHierarchy && categoryHierarchy.slice(-1)[0]) ||
			selectedDimensionName ||
			EMPTY_VALUE
		);
	};

	getTaxonomyName = () => {
		const {
			divisionName,
			categoryName,
			supplierName,
			dimensions,
			categoryHierarchy,
			dimensionName,
			selectedDimensionKeyTitle,
		} = this.props;

		if (categoryName || categoryHierarchy) {
			return TAXONOMY_NAMES.category;
		}

		if (divisionName) {
			return TAXONOMY_NAMES.division;
		}

		if (supplierName) {
			return TAXONOMY_NAMES.vendor;
		}

		if (dimensionName) {
			return DIMENSION_LABELS[dimensions[0]];
		}

		if (selectedDimensionKeyTitle) {
			return selectedDimensionKeyTitle;
		}

		return '';
	};

	getWaterfallFilters = () => {
		const { supplierId, waterfallFilter, isHarmonized } = this.props;
		const vendorFilterName = !isHarmonized
			? VENDOR_TYPES.original
			: VENDOR_TYPES.harmonized;

		if (
			!waterfallFilter ||
			(supplierId && vendorFilterName === waterfallFilter[0])
		) {
			return [];
		}

		return [waterfallFilter[2]];
	};

	getTags = () => {
		const {
			showNonSourceable,
			includeCustomCategories,
			showNegativeSpend,
			useNetSpend,
			hierarchy,
			categoryName,
			categoryHierarchy,
			customFilterOptions,
			dimensionName,
			extraFilters,
			isPmi,
			spendType,
			selectedDimensionKey,
			selectedDimensionId,
		} = this.props;
		const { customFilters } = this.getCustomFilters();
		const sourceableFilter =
			showNonSourceable === 'true' ? 'Non-sourceable' : 'Sourceable';
		const waterfallFilters = this.getWaterfallFilters();
		const customFiltersOccurances = customFilters.reduce((acc, filter) => {
			if (!acc[filter]) {
				const customFilterObj = customFilterOptions.find(
					item => item.name === filter
				);
				return {
					...acc,
					[filter]: {
						count: 1,
						label: customFilterObj ? customFilterObj.label : filter,
					},
				};
			}

			return {
				...acc,
				[filter]: { ...acc[filter], count: acc[filter].count + 1 },
			};
		}, {});

		const isCategoryItem = categoryName || categoryHierarchy;
		let taxonomyType = isCategoryItem
			? [!includeCustomCategories ? 'AP Taxonomy' : 'Client taxonomy']
			: [];

		if (selectedDimensionId) {
			let isDirect;
			if (selectedDimensionId.startsWith('Direct')) {
				isDirect = true;
			} else if (selectedDimensionId.startsWith('Indirect')) {
				isDirect = false;
			} else {
				console.warn('Does not start with Direct or Indirect');
			}

			if (isDirect) {
				taxonomyType = ['Client taxonomy'];
			}
		} else {
			if (spendType === 'DIRECT') {
				taxonomyType = ['Client taxonomy'];
			}
		}

		const dimensionFilter = isCategoryItem
			? waterfallFilters
			: hierarchy
				? [hierarchy.slice(-1)[0]]
				: !dimensionName
					? waterfallFilters
					: [];
		let extraTags = [];

		if (extraFilters) {
			extraTags = Object.keys(extraFilters).reduce((acc, filterName) => {
				if (extraFilters[filterName].length > 1) {
					return [
						...acc,
						`${capitilize(filterName)} (${extraFilters[filterName].length})`,
					];
				}

				return [...acc, extraFilters[filterName]];
			}, []);
		}

		if (isPmi && spendType && selectedDimensionKey !== 'spendType') {
			extraTags = [...extraTags, capitilize(spendType)];
		}

		return [
			sourceableFilter,
			useNetSpend || showNegativeSpend ? 'Net spend' : 'Positive spend',
			...taxonomyType,
			...dimensionFilter,
			...extraTags,
			...Object.keys(customFiltersOccurances).map(
				name =>
					`${customFiltersOccurances[name].label} (${
						customFiltersOccurances[name].count
					})`
			),
		];
	};

	render() {
		const {
			dateFrom,
			dateTo,
			showNonSourceable,
			onClose,
			isOpen,
			categoryHierarchy,
			hierarchy,
			categoryName,
		} = this.props;
		const { selectedOption, isLoading, isSourceable } = this.state;
		const isCategoryItem = categoryName || categoryHierarchy;
		const subheaderItems = isCategoryItem
			? categoryHierarchy
				? categoryHierarchy.slice(0, -1)
				: hierarchy || []
			: [];

		return (
			<Wrapper onClick={e => e.stopPropagation()}>
				<StyledModal
					isOpen={isOpen}
					header="Edit sourceable status"
					isDismissible
					hasClosed={onClose}
					isLoading={isLoading}
					footer={
						!isLoading
							? ({ handleClose }) => {
									return (
										<ApButtonGroup justifyContent="flex-end">
											<StyledButtonSecondary onClick={handleClose}>
												Cancel
											</StyledButtonSecondary>
											<ApButtonMain
												onClick={this.updateSelectedSpendType}
												disabled={
													isLoading ||
													isSourceable == null ||
													selectedOption == null
												}
											>
												Save Changes
											</ApButtonMain>
										</ApButtonGroup>
									);
							  }
							: () => (
									<LoadingFooter>
										This window will close automatically when the change has
										been completed
									</LoadingFooter>
							  )
					}
				>
					<SubheaderSection>
						<SubheaderText>{this.getName()}</SubheaderText>
						<SubheaderHelper>{subheaderItems.join(' / ')}</SubheaderHelper>
						<SubheaderTags>
							{this.getTags().map((tag, i) => (
								<ApChip key={i} small>
									{tag}
								</ApChip>
							))}
						</SubheaderTags>
					</SubheaderSection>

					<Content>
						{isLoading && (
							<LoadingWrapper>
								<ApLoaderDefault loaderText={() => <ApLoaderText />} />
							</LoadingWrapper>
						)}
						<Section>
							<SectionTitle>1. Change the status for:</SectionTitle>
							<RadioGroup
								name="spend-transactions"
								value={selectedOption}
								onChange={this.onTransactionChange}
							>
								<StyledRadio
									value={OPTIONS.ALL_FILTERS}
									active={selectedOption === OPTIONS.ALL_FILTERS}
								>
									Transactions in the selected view and applied filters
								</StyledRadio>
								<StyledRadio
									value={OPTIONS.DATE_ONLY}
									active={selectedOption === OPTIONS.DATE_ONLY}
								>
									All transactions in {getPeriodString(dateFrom, dateTo)}
								</StyledRadio>
								<StyledRadio
									value={OPTIONS.ALL}
									active={selectedOption === OPTIONS.ALL}
								>
									All transactions for this {this.getTaxonomyName()}
								</StyledRadio>
							</RadioGroup>
						</Section>
						<Section>
							<SectionTitle>2. Mark the transactions as:</SectionTitle>
							<RadioGroup
								name="spend-type"
								value={isSourceable}
								onChange={this.onSpendTypeChange}
							>
								<StyledRadio
									value={true}
									active={isSourceable === true}
									disabled={
										!selectedOption ||
										(selectedOption === OPTIONS.ALL_FILTERS &&
											showNonSourceable !== 'true')
									}
								>
									Sourceable
								</StyledRadio>
								<StyledRadio
									value={false}
									active={isSourceable === false}
									disabled={
										!selectedOption ||
										(selectedOption === OPTIONS.ALL_FILTERS &&
											showNonSourceable === 'true')
									}
								>
									Non-sourceable
								</StyledRadio>
							</RadioGroup>
						</Section>
					</Content>
				</StyledModal>
			</Wrapper>
		);
	}
}

export default props => (
	<ApiDataContext.Consumer>
		{({ clearApiCache }) => (
			<SettingsContext.Consumer>
				{({ customFilters: customFilterOptions }) => (
					<QueryStringContext.Consumer>
						{({
							customFilters,
							customFiltersValues,
							waterfallFilter,
							dateFrom,
							dateTo,
							measures,
							showNonSourceable,
							showHarmonizedVendors,
							showNegativeSpend,
							storedQueryId,
							storedQuery,
							indirectTaxonomy,
							directTaxonomy,
						}) => (
							<ChangeTypeModal
								dateFrom={dateFrom}
								dateTo={dateTo}
								customFilters={convertToArray(customFilters)}
								customFiltersValues={convertToArray(customFiltersValues)}
								waterfallFilter={waterfallFilter}
								customFilterOptions={customFilterOptions}
								hierarchy={measures}
								showNonSourceable={showNonSourceable}
								clearApiCache={clearApiCache}
								isHarmonized={showHarmonizedVendors === 'true'}
								showNegativeSpend={
									props.showNetSpend && showNegativeSpend === 'true'
								}
								storedQueryId={storedQueryId}
								storedQuery={storedQuery}
								indirectTaxonomy={indirectTaxonomy}
								directTaxonomy={directTaxonomy}
								// Added to set hierarchy and other props manually
								{...props}
							/>
						)}
					</QueryStringContext.Consumer>
				)}
			</SettingsContext.Consumer>
		)}
	</ApiDataContext.Consumer>
);

const getPeriodString = (dateFrom, dateTo) => {
	const yearFrom = getYearByDate(dateFrom);
	const yearTo = getYearByDate(dateTo);
	const monthTo = getMonthByDate(dateTo);
	const monthFrom = getMonthByDate(dateFrom);

	if (yearTo === yearFrom) {
		const months =
			getMonthByDate(dateTo) - getMonthByDate(dateFrom) === 11
				? 'Full Year'
				: `${MONTH_NAMES[monthFrom]} - ${MONTH_NAMES[monthTo]}`;
		return `${yearFrom} (${months})`;
	} else {
		return `${MONTH_NAMES[monthFrom]} ${yearFrom} - ${
			MONTH_NAMES[monthTo]
		} ${yearTo}`;
	}
};
